// extracted by mini-css-extract-plugin
export default {"text":"HomePage_text__2XixT","animate":"HomePage_animate__bspDu","image":"HomePage_image__Su6Pd","bottomText":"HomePage_bottomText__7ld9Z","link":"HomePage_link__-d+Of"};